import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import HomeScreen from "../screens/HomeScreen";
import NameDetailsScreen from "../screens/NameDetailsScreen";

const Stack = createStackNavigator();

const HomeStackNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerTitleStyle: {
          fontFamily: "Urbanist_700Bold",
          fontSize: 20,
          color: "#333",
        },
        headerStyle: {
          backgroundColor: "#F9FAFB",
        },
      }}
    >
      <Stack.Screen
        name="Home"
        component={HomeScreen}
        options={{ headerShown: false }} // Oculta el encabezado en la pantalla principal
      />
      <Stack.Screen
        name="NameDetails"
        component={NameDetailsScreen}
        options={{
          headerTitle: "Name Details", // Título del encabezado
        }}
      />
    </Stack.Navigator>
  );
};

export default HomeStackNavigator;
